import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'medium',
  fullWidth = false,
  disabled = false,
  onClick,
  type = 'button',
  className = '',
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center justify-center gap-2 font-medium rounded-md transition-colors duration-150 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 disabled:opacity-50 disabled:cursor-not-allowed';

  const variantClasses = {
    primary: 'bg-accent text-surface-base hover:bg-accent-hover active:bg-accent-pressed',
    secondary: 'bg-surface-overlay text-text-primary border border-surface-border hover:border-accent/30 hover:text-accent',
    outline: 'bg-transparent text-text-secondary border border-surface-border hover:bg-surface-overlay hover:text-text-primary',
    ghost: 'bg-transparent text-text-secondary hover:bg-surface-overlay hover:text-text-primary',
    danger: 'bg-transparent text-status-overdue border border-transparent hover:border-status-overdue/30 hover:bg-status-overdue-bg',
    icon: 'bg-transparent text-text-muted hover:text-text-secondary hover:bg-surface-overlay',
  };

  const sizeClasses = {
    small: 'px-3 py-1.5 text-xs',
    medium: 'px-4 py-2 text-sm',
    large: 'px-5 py-2.5 text-sm',
  };

  const widthClass = fullWidth ? 'w-full' : '';

  const combinedClasses = `${baseClasses} ${variantClasses[variant] || variantClasses.primary} ${sizeClasses[size] || sizeClasses.medium} ${widthClass} ${className}`.trim();

  return (
    <button
      type={type}
      className={combinedClasses}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
